export default __webpack_public_path__ + "static/stone-style-3-26941afecc5d52c56e41c1ab504d32f7.png";